import Layout from 'components/Layout';
import ContactCard from 'components/UI/ContactCard/ContactCard';
import Container from 'components/UI/Container';
import PageHeader from 'components/UI/PageHeader/PageHeader';
import React from 'react';
import './Contact.modules.scss';
import SideButtons from 'components/UI/SideButtons/SideButtons';
import Button from 'components/UI/Button';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessages } from '@fortawesome/pro-solid-svg-icons';

export default function Contact() {
    const history = useHistory();

    return (
        <Layout>
            <PageHeader />
            <Container>
                {/* <HeroLayout /> */}
                <div styleName="page-wrapper">
                    <div styleName="contact">
                        <div styleName="contact-person">
                            <h2>Neem contact op</h2>
                            <p>
                                Wil je meer weten neem dan contact op met de
                                adviseur van ons onderwijsloket.
                                <br />
                                <br />
                                In de zomervakantie is het loket gesloten. Je
                                kunt wel alvast een e-mail sturen, maar we zijn
                                pas in de gelegenheid om berichten te
                                beantwoorden vanaf 18 augustus. Bekijk in de
                                tussentijd{' '}
                                <a
                                    styleName="link"
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://www.onderwijsloket.com/"
                                >
                                    www.onderwijsloket.com
                                </a>
                                .
                            </p>
                            <ContactCard big blueGray />
                        </div>
                        <div styleName="contact-form">
                            <h2>Contactformulier</h2>
                            <div styleName="content">
                                <p>
                                    Voor je het contactformulier in kunt vullen,
                                    hebben we eerst vijf vragen voor je. De
                                    vragen helpen je verder bij jouw oriëntatie
                                    en met de antwoorden kunnen we jou beter
                                    adviseren.
                                    <br />
                                    <br />
                                    In de zomervakantie is het loket gesloten.
                                    Je kunt wel alvast het formulier invullen,
                                    maar we zijn pas in de gelegenheid om
                                    berichten te beantwoorden vanaf 18 augustus.
                                    Bekijk in de tussentijd{' '}
                                    <a
                                        styleName="link"
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.onderwijsloket.com/"
                                    >
                                        www.onderwijsloket.com
                                    </a>
                                    .
                                </p>
                                <Button onClick={() => history.push('test')}>
                                    Verder
                                    <FontAwesomeIcon icon={faMessages} />
                                </Button>
                            </div>
                            {/* <ContactForm /> */}
                        </div>
                    </div>
                    <SideButtons />
                </div>
            </Container>
        </Layout>
    );
}
